<template>
  <div v-if="show" class="modal-overlay">
    <div class="confirm-modal">
      <button class="close-button" @click="handleClose">×</button>

      <div class="modal-content">
        <h2 class="modal-title">{{ displayTitle }}</h2>
        <p class="modal-message">{{ message }}</p>

        <router-link v-if="showLogin" to="/login" class="login-link" @click="handleClose">{{ $t('modals.unauthorized.go_to_login') }}</router-link>

        <div class="modal-buttons">
          <button class="cancel-button" @click="handleClose">{{ $t('modals.unauthorized.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnauthorizedUserModal',
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, default: '' },
    message: { type: String, required: true },
    showLogin: { type: Boolean, default: false },
  },
  computed: {
    displayTitle() {
      return this.title || this.$t('modals.unauthorized.title')
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.confirm-modal {
  background-color: #fff;
  border-radius: 12px;
  padding: 24px 28px;
  width: 400px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  text-align: center;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.modal-title {
  font-size: 20px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #333;
}

.modal-message {
  font-size: 16px;
  margin-bottom: 18px;
  color: #555;
}

.login-link {
  margin: 10px 0;
  color: var(--primary-color, #007bff);
  font-weight: 600;
  text-decoration: underline;
  font-size: 15px;
}

.modal-buttons {
  margin-top: 16px;
}

.cancel-button {
  background-color: var(--primary-color, #007bff);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-button:hover {
  background-color: #0056b3;
}
</style>
